// import IssuedClientInvoice from "../../containers/AddTransaction/TransactionDynamicField/IssuedClientInvoice/IssuedClientInvoice";
// TODO ---- use ojects and translation keys
// TODO ---- use ojects and translation keys
// TODO ---- use ojects and translation keys

import { stubTrue } from "lodash";

// #region User Status
export const UserStatusActiveId = "d5b8c280-27a6-4097-a91c-190db574f550";
export const UserStatusDisabledId = "6254012f-0297-4be6-b934-251c26986189";
// #endregion
//#region User Activity History
export const UserActionReadingSecrets = "Reading legal entity secrets";
export const UserActionSavingSecrets = "Saving legal entity secrets";
export const UserActionDownloadFile = "Download file";
export const UserActionDownloadFiles = "Download files";
export const UserActionUploadFile = "Upload file";
export const UserActionSavingFileMetadata = "Saving file metadata";
//#endregion User Activity History
//#region User Activity AboutItems
export const AboutItemKindFile = "File";
export const AboutItemKindDocument = "Document";
export const AboutItemKind2FaMethod = "2FaMethod";
export const AboutItemKind2FaCode = "2FaCode";
export const AboutItemKindSecret = "Secret";
//#endregion User Activity AboutItems

// Remark: for now let transaction status and document status and clarification status have the same ID value
// so that if necessary they become IDs of a single StatusEntity commonly used for multiple entities.
// #region Transaction Statuses
export const TRANSACTION_STATUS_TYPES = {
  PENDING: {
    id: "1c7f38ad-37a4-4fbd-b724-2d6c04f35815",
    name: "Pending",
    code: "",
    description: "",
  },
  CLARIFICATION_REQUESTED: {
    id: "353fa321-fe7b-49c7-8fd5-a1c9943339cf",
    name: "Clarification requested",
    code: "",
    description: "",
  },
  VERIFIED: {
    id: "ef3c4694-1505-4f6c-b911-622ec6502712",
    name: "Verified",
    code: "",
    description: "",
  },
  PROCESSED: {
    id: "8c720045-bf6e-42c8-a708-25d37c42497f",
    name: "Processed",
    code: "",
    description: "",
  },
};
// #endregion Transaction Statuses

// #region Legislations
export const ALL_LEGISLATIONS_ID = "fdc1c3ac-69ff-4c3c-aa56-2e51220bfca9";
// #endregion Legislations

// #region Document Statuses
export const DOCUMENTS_STATUS_TYPES = {
  PENDING: {
    id: "1c7f38ad-37a4-4fbd-b724-2d6c04f35815",
    name: "Pending",
    code: "Pending",
    description: "Pending verification (when created)",
    isDeleted: false,
    isConstant: true,
  },
  CLARIFICATION_REQUESTED: {
    id: "353fa321-fe7b-49c7-8fd5-a1c9943339cf",
    name: "Clarification requested",
    code: "Clarification",
    description: "Clarification from client requested (before verifying)",
    isDeleted: false,
    isConstant: true,
  },
  VERIFIED: {
    id: "ef3c4694-1505-4f6c-b911-622ec6502712",
    name: "Verified",
    code: "Verified",
    description: "Is verified (after pending or clarified)",
    isDeleted: false,
    isConstant: true,
  },
  PROCESSED: {
    id: "8c720045-bf6e-42c8-a708-25d37c42497f",
    name: "Processed",
    code: "Processed",
    description: "Is processed (after verified)",
    isDeleted: false,
    isConstant: true,
  },
};
// #endregion Document Statuses

// #region Clarification Statuses
export const CLARIFICATION_STATUS_TYPES = {
  PENDING: {
    id: "1c7f38ad-37a4-4fbd-b724-2d6c04f35815",
    name: "Pending",
  },
  CLARIFICATION_REQUESTED: {
    id: "353fa321-fe7b-49c7-8fd5-a1c9943339cf",
    name: "Clarification requested",
  },
  VERIFIED: {
    id: "ef3c4694-1505-4f6c-b911-622ec6502712",
    name: "Verified",
  },
  PROCESSED: {
    id: "8c720045-bf6e-42c8-a708-25d37c42497f",
    name: "Processed",
  },
};
// #endregion Clarification Statuses

//#region document reports
export const DOCUMENTS_REPORTS = {
  COMPLIANCE_REPORT_ID: "ac9a21e7-495f-46c4-800f-0622396977ec",
  INVOICE_TRACKING_REPORT_ID: "586af51c-8d23-40aa-8313-e87153de26dc",
  PAYROLL_OUTPUT_REPORT_ID: "3f3db6fb-5100-4136-9313-eb5f72bb9a9b",
  ACCOUNTING_OUTPUT_REPORT_ID: "ff666541-33c5-4749-a54f-fd731e01558a",
};
//#endregion

//#region transaction types
export const TRANSACTION_TYPES = {
  PAID_BANK_FEE_ID: "70151bde-1505-43c1-9ae2-bdf156bee2f0",
  MADE_A_DONATION_ID: "79fd2bd6-0fcb-4c70-a56e-98b2202eba3f",
  RECEIVED_A_DONATION_ID: "7d0aac9b-9d5c-4144-8fa6-7d192d9d76aa",
  COLLECTED_CLIENT_INVOICE_ID: "9769c514-bccc-4d19-93cd-08ea3d00ef49",
  ISSUED_CLIENT_INVOICE_ID: "9c2c0d84-5cc1-4806-86f8-0bf75b0f08bf",
  RECEIVED_MEMBERSHIP_FEE_ID: "aaf66288-184e-4625-b91f-050f21b3e319",
  PAID_VENDOR_INVOICE_ID: "beadfc81-8439-4acd-b515-204346d9c5ef",
  RECEIVED_VENDOR_INVOICE_ID: "f45e70ac-2b55-4747-8d3b-e709e7407a82",
};
//#endregion

// #region mutation statuses
export const MUTATIONS_STATUSES = {
  PENDING: {
    id: "f82e088e-bd7e-4234-a0ab-37f63583f0ab",
    name: "Pending",
  },
  APPROVED: {
    id: "4d8f75b1-470a-4939-a253-77960f97650b",
    name: "Approved",
  },
  REJECTED: {
    id: "2df5bcfb-ed73-4967-a277-8c973eca2b97",
    name: "Rejected",
  },
};
//#endregion

//#region two factor ( 2fa ) auth methods
export const TWO_FACTOR_AUTH_METHODS = {
  NONE: {
    id: "3af6bed7-850b-403d-b0e0-7c9a34fef42c",
    name: "No two-factor authentication",
    isDeleted: false,
    isConstant: true,
  },

  EMAIL: {
    // this one is default
    id: "c76a2b4c-caf2-4a31-9423-b65438586b65",
    name: "Email",
    isDeleted: false,
    isConstant: true,
  },

  SMS: {
    id: "27774b8c-0980-40ff-8369-d436c7ebcf1b",
    name: "SMS",
    isDeleted: false,
    isConstant: true,
  },
  GoogleAuthr: {
    id: "11ba7558-d856-4fbf-8221-f994a576136b",
    name: "Google Authenticator",
    isDeleted: false,
    isConstant: true,
  },
  MsAuthr: {
    id: "a67465cd-d9c8-4df5-8ed3-3e8dc4d98474",
    name: "Microsoft Authenticator",
    isDeleted: false,
    isConstant: true,
  },
}; // SMS {27774b8c-0980-40ff-8369-d436c7ebcf1b}, MicrosoftAuthenticator {a67465cd-d9c8-4df5-8ed3-3e8dc4d98474}, GoogleAuthenticator {11ba7558-d856-4fbf-8221-f994a576136b}
//#endregion

//#region document categories
export const DOCUMENT_CATEGORIES = {
  CORPORATE_CHANGES: {
    id: "2fc6148f-61d9-4bdb-9d43-fc0153f601ef",
  },
  OTHER: {
    id: "87b26c13-624f-4f2b-a737-18bf70d00998",
  },
  PAYROLL_INPUT: {
    id: "a0d91391-655a-4e3a-8046-657c1d0abb54",
    name: "Payroll input",
  },
  ACCOUNTING_INPUT: {
    id: "5f523a5c-0903-4e58-9db2-2eca4acdc1ca",
    name: "Accounting input",
  },
  POLICIES: {
    id: "2591e951-6d07-4556-ada3-3d62cbb44993",
    name: "Policies",
  },
  PAYROLL_OUTPUT: {
    id: "894bc9d1-88bf-4e20-83ba-0240d4918709",
    name: "Payroll Output",
  },
  VENDOR_AND_CLIENT_CONTRACTS: {
    id: "43744cf1-c69a-4222-89a5-332e4f14e6da",
    name: "Vendor and client contracts",
  },
  EMPLOYMENT_DOCUMENTS: {
    id: "551780a3-e483-4921-9c3f-8007429b6ba6",
    name: "Employment documents",
  },
  PERSONNAL_DOCUMENTS: {
    id: "b1b4a31a-5c02-4539-a200-96fbd8b22072",
    name: "Personnal documents",
  },
  POAS: {
    id: "804c0165-fbed-4b3d-8f39-6e37d6e3c137",
    name: "PoAs",
  },
};
//#endregion

//#region  DOCUMENT TYPES
export const DOCUMENT_TYPES = {
  ProformaEmployeeCostReport: {
    id: "a8d6cea2-3a6e-4186-aaf6-dd1ef2edc046",
    name: " Proforma employee cost report",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  PayrollInputAdHoc: {
    id: "7056a89d-1682-4873-940b-563bf9efb487",
    name: "Adhoc payroll input",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  AccountingInputOther: {
    id: "18e8f6a9-7930-4186-9993-9fc6ac8398e4",
    name: "Adhoc accounting input",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  ClientInvoices: {
    id: "108a09c2-840d-47e9-b054-0b6dbda694bf",
    name: "Client Invoices",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  VendorInvoices: {
    id: "4a258c29-fc05-4163-832c-d4c83bcb4774",
    name: "Vendor Invoices",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  BankStatements: {
    id: "6fcff5e7-63b5-4b76-8c8a-74e3c3c156e1",
    name: "Bank statements",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  CashReceipt: {
    id: "6f0dedf6-ac53-4358-87e8-121779dfaf79",
    name: "Cash receipt",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
  },
  EmployeeCV: {
    id: "2f778988-9b64-4cc4-ae01-f4f4034b4be6",
    name: "Employee CV",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.OTHER,
  },
  CompanyPolicy: {
    id: "e3ea8d15-2b2f-4b8d-bd6c-e713ff8b1a61",
    name: "Company Policy",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.POLICIES,
  },
  TravelExpensesReceipt: {
    id: "4841e489-17df-4ce9-83cd-32a44034e24a",
    name: "Travel expense receipt",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.ACCOUNTING_INPUT,
  },
  LoanRequest: {
    id: "75a587ea-fa89-49b6-8f5b-ed1c8332e255",
    name: "Loan request",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.ACCOUNTING_INPUT,
  },
  GeneralCashPoolAgreement: {
    id: "0c3071dd-5e96-4140-8af8-9877a70cca08",
    name: "General cash pool agreement",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.ACCOUNTING_INPUT,
  },
  AllPayslips: {
    id: "ca3446e3-de0d-4582-b9a0-0210960e9981",
    name: "All Payslips",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PAYROLL_OUTPUT,
  },
  SourceGrossToNet: {
    id: "07ceb2ab-9b4d-4fee-8938-f24078203d31",
    name: "Source Gross To Net",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PAYROLL_OUTPUT,
  },
  PayrollBankFile: {
    id: "8647051c-49bc-424a-b954-6b5597de249b",
    name: "Payroll bank file", //TODO check
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PAYROLL_OUTPUT,
  },
  FluctuationsReport: {
    id: "27ae6fd6-bedf-41b8-ac8b-48e41c54e7be",
    name: "Fluctuations report",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PAYROLL_OUTPUT,
  },
  PayrollBookingFile: {
    id: "a9ef47d0-a019-4353-8aa6-8d9197fe1192",
    name: "Payroll booking file",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PAYROLL_OUTPUT,
  },

  ClientContracts: {
    id: "42c15ed7-0f93-4622-820e-43b8930548ae",
    name: "Client contracts",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.VENDOR_AND_CLIENT_CONTRACTS,
  },
  VendorContracts: {
    id: "371ab35f-869c-480d-b9f5-6196f06cca4e",
    name: "Vendor contracts",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.VENDOR_AND_CLIENT_CONTRACTS,
  },
  ProjectAssignment: {
    id: "04df80d1-bda1-4c52-9982-c05965e00196",
    name: "Project assignment",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.VENDOR_AND_CLIENT_CONTRACTS,
  },
  WorkWorder: {
    id: "a6109f39-701a-43c3-9881-36ef22eab812",
    name: "Work Order",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.VENDOR_AND_CLIENT_CONTRACTS,
  },
  ProjectDescription: {
    id: "a4ce42bd-cced-4a28-9d1a-108b33016825",
    name: "Project description",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.EMPLOYMENT_DOCUMENTS,
  },
  EmployeePayslip: {
    id: "243fe612-109f-44bd-85f3-02926c12b663",
    name: "Employee payslip",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.EMPLOYMENT_DOCUMENTS,
  },
  AbsenceDocumentation: {
    id: "06cbf377-2853-49a4-9b1c-65eab5d16889",
    name: "Absence Documentation",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.OTHER,
  },
  DocumentToSplit: {
    id: "24a32d39-60e1-4f6e-aadb-e23fbc8e70e9",
    name: "Document To Split",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.OTHER,
  },
  Template: {
    id: "e04f7a55-78a1-4c8a-bbed-203389ade035",
    name: "Template",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.OTHER,
  },
  Passport: {
    id: "bbb170be-7ffe-43c1-9614-1a9c88ea5db1",
    name: "Passport",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PERSONNAL_DOCUMENTS,
  },
  NationalId: {
    id: "e0b06b58-c402-4c45-a75c-3243eb69fe16",
    name: "National ID",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PERSONNAL_DOCUMENTS,
  },
  ProofOfAddress: {
    id: "99429b8f-75ab-44fd-b5c6-d61f161c274b",
    name: "Proof of address",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PERSONNAL_DOCUMENTS,
  },
  TaxResidencyCertificate: {
    id: "8bf488f0-f292-4e8e-b3ba-8c07a214b807",
    name: "Tax residency certificate",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.PERSONNAL_DOCUMENTS,
  },
  PoAUnspecified: {
    id: "787fa07b-7b17-479f-8a1f-a92f431e95a9",
    name: "PoA (Unspecified)",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.POAS,
  },
  Other: {
    id: "b3915a0f-f35c-48ff-a0fe-c74544f7561d",
    name: "Other",
    legislation: {
      id: ALL_LEGISLATIONS_ID,
    },
    category: DOCUMENT_CATEGORIES.OTHER,
  },
};
//#endregion

//#region accounting entry status
export const ACCOUNTING_ENTRY_STATUS = {
  Pending: {
    id: "d6746b68-c29d-4409-be4f-b840f4b3e57a",
    name: "Pending",
  },
};
//#endregion

//#region Payroll entry status
export const PAYROLL_ENTRY_STATUS = {
  Pending: {
    id: "48e23c10-4f2b-4ac7-94ce-003d3e96bebe",
    name: "Pending",
  },
  Cancelled: {
    id: "0a4b63f7-147e-4ddb-9005-39410caa38ad",
    name: "Cancelled",
  },
};
//#endregion

//#region payroll run status
export const PAYROLL_RUN_STATUSES = {
  Editable: {
    id: "3d0417dd-7bbd-4b4b-ad91-a8f97c78bbba",
    name: "Editable",
    code: "EDTBL",
    isDeleted: false,
    isConstant: true,
  },
  Closed: {
    id: "b82bb5ea-b85c-46b0-9682-1ea10c18f581",
    name: "Closed",
    code: "CLOSED",
    isDeleted: false,
    isConstant: true,
  },
};
//#endregion

//# region porsition candidate status
export const POSITION_CANDIDATE_STATUSES = {
  cVsSentToClientInProgress: {
    id: "b5e7aa4a-a6fa-41e6-8677-5d4ef2d357cb",
    name: "CV sent to client - In progress",
  },
  cVsSentToClientDeclined: {
    id: "8696b871-ed3b-40b5-b3bb-59e59d9867bf",
    name: "CV sent to client - Declined",
  },
  cVsInterviewedByClientInProgress: {
    id: "f496c68d-3473-481f-8ec5-985c63bc192f",
    name: "CV interviewed by client - In progress",
  },
  cVsInterviewedByClientDeclined: {
    id: "aa82e9c7-9bb7-4686-a528-678aa4e3a844",
    name: "CV interviewed by client - Declined",
  },
  cVsInOfferInProgress: {
    id: "1bbe6633-e6d1-4e92-958b-98bfc5ee01dc",
    name: "CV in offer - In progress",
  },
  cVsInOfferDeclined: {
    id: "8b8dfc5e-8cc5-49fc-b78f-190cb6ece47d",
    name: "CV in offer - Declined",
  },
  cVsHired: {
    id: "593b918e-c5d8-407f-ac48-48edbba7c2a1",
    name: "CV Hired",
  },
  cVsOfferRejected: {
    id: "2bed067e-7426-4dd0-8106-c98bb0f2ac5c",
    name: "CV Offer Rejected",
  },
};
//#endregion

//#region availability status
export const AVAILABILITY_STATUSES = {
  immediat: {
    id: "de4c8619-f332-499f-9988-acedc6916629",
    name: "Immediate",
  },
  oneWeek: {
    id: "da6224c8-bac5-4e76-97ac-cf5734499daa",
    name: "One week",
  },
  twoWeeks: {
    id: "61f6f848-7446-4972-9ef2-33eb2bcb2be8",
    name: "2 weeks",
  },
  oneMonth: {
    id: "aa94c1ce-663c-4232-900a-a5211367a899",
    name: "One month",
  },
  twoMonth: {
    id: "b164717a-4997-470a-b000-bdb5dae52487",
    name: "2 months",
  },
  onHold: {
    id: "d6eb2eb2-b21a-45cb-aae5-c9738447352b",
    name: "On-hold",
  },
};
//#endregion

// #region bank types
export const BANK_TYPES = {
  bank_accounts: {
    id: "e2efe0f7-9bdc-4d70-8b35-42b4e8201507",
    name: "",
    code: "",
    isDeleted: false,
    isConstant: true,
  },
  cashStatements: {
    id: "b22f9a9a-e3ac-4ff2-a69f-f10caf631ad9",
    name: "",
    code: "",
    isDeleted: false,
    isConstant: true,
  },
};
//#endregion

// #skills category
export const SKILLS_CATEGORIES = {
  technical: {
    id: "3729cb31-e6e6-4d3e-9c56-9e35f009a25e",
    name: "Technical",
  },
  personal: {
    id: "a3d7bb69-df4a-49c4-99e4-28e7e86bd31e",
    name: "Personal",
  },
  language: {
    id: "dabac1a7-9d2b-467d-b084-353112913524",
    name: "Language",
  },
};
//#endregion

//#region expense report status
export const EXPENSE_REPORT_STATUS = {
  paid: {
    id: "75bdf367-c0d9-457a-ba0c-fb04b7088616",
    name: "Paid",
    code: "PAID",
    isDeleted: false,
    isConstant: true,
  },
  cancelled: {
    id: "7aa25f67-75d2-477a-83da-dff74d2ed481",
    name: "Cancelled",
    code: "CNLD",
    isDeleted: false,
    isConstant: true,
  },
  submitted: {
    id: "860e5419-ed40-4b75-9958-44e800106568",
    name: "Submitted",
    code: "SBMT",
    isDeleted: false,
    isConstant: true,
  },
  draft: {
    id: "a2f653cb-cd5d-4822-b238-58e308b7a5ea",
    name: "Draft",
    code: "DRAFT",
    isDeleted: false,
    isConstant: true,
  },
  returned_to_employee: {
    id: "bc1fe015-7ae0-419f-885d-09c1ac3b92bb",
    name: "Returned to employee",
    code: "RTE",
    isDeleted: false,
    isConstant: true,
  },
  approved: {
    id: "d6710911-62cb-4b62-a386-ec5548473e36",
    name: "Approved",
    code: "APRVD",
    isDeleted: false,
    isConstant: true,
  },
  rejected: {
    id: "e17b1178-7bdb-41e2-be0f-1588037da682",
    name: "Rejected",
    code: "RJD",
    isDeleted: false,
    isConstant: true,
  },
} as const;
//#endregion

//#region audit types
export const AUDIT_TYPES = {
  employee_permanent_documents: {
    id: "084184ff-1c83-4603-aaae-612400317e2e",
    code: "EPD",
    name: "Employee permanent document",
    isConstant: true,
  },
  AVS_CH: {
    id: "4dd1ed06-9805-429d-8c74-acf2d59d13c8",
    code: "AVS",
    name: "AVS_CH",
    isConstant: true,
  },
  Payroll: {
    id: "55ccf75b-55dd-403c-99ff-b63fe2d0f798",
    code: "Pay",
    name: "Payroll",
    isConstant: true,
  },
  Compliance: {
    id: "a23b5515-6119-44db-8fa1-068cbdece159",
    code: "CPL",
    name: "Compliance",
    isConstant: true,
  },
  Corporate_changes: {
    id: "a891f996-d88e-4ac5-a6fd-28cdb5cca3ba",
    code: "CORCHA",
    name: "Corporate changes",
    isConstant: true,
  },
  Registrations_docs: {
    id: "a917cf56-74f4-4007-a9fe-9af7877a4183",
    code: "REGDOC",
    name: "Registrations docs",
    isConstant: true,
  },
  Employee_changing_document: {
    id: "f7d62057-6b77-484c-8afa-62d99cbff7ec",
    code: "ECD",
    name: "Employee changing document",
    isConstant: true,
  },
  Company_permanent_document: {
    id: "97b5f3d1-b9f9-4548-88f4-1823f81bfb96",
    code: "CPD",
    name: "Company permanent documents",
  },
  Company_changing_document: {
    id: "b51e0f97-fda1-431b-9821-25bcb7b3e06b",
    code: "CCD",
    name: "Company changing documents",
  },
  Company_documents_overview: {
    id: "a51e0f97-fdb1-531a-7821-25abc7b3e06a",
    code: "CDO",
    name: "Company document overview",
  },
};
//#endregion

//#region user status
export const USER_STATUS = {
  active: {
    id: "d5b8c280-27a6-4097-a91c-190db574f550",
    name: "Active",
  },
  disabled: {
    id: "6254012f-0297-4be6-b934-251c26986189",
    name: "Disabled",
  },
};
//#endregion

// #region absence types
export const ABSENCE_TYPES = {
  FullDay: {
    id: "639e5ed8-ae71-4bcd-b1e6-cfa1e7173f2f",
  },
  HalfDay: {
    id: "45b01431-9c88-43ff-ac19-908d6303b008",
  },
  PaidLeave: {
    id: "3a549ccc-12c2-4191-8f97-f2e135fa865a",
  },
  BusinessTrip: {
    id: "03aed209-15cd-4368-9ba5-845b8ea6234e",
  },
};
//#endregion

//#region digest notification types
export const DIGEST_NOTIFICATION_TYPES = {
  my_own_timesheet: {
    id: "5e1d5e22-1275-441f-81e4-1bcd7f6ae388",
  },
  my_team_timesheet: {
    id: "005f079e-0234-4908-a0f1-2c7a4c706aea",
    sections: {
      DueVSActualWorkedTimeId: "bb6d6510-f87c-4ce5-a390-37a46e88ac76",
      MissingClockingsOrAnomaliesId: "d6bb0482-0be4-4b79-9eff-367633d2d878",
      PendingApprovalsId: "46c2938e-e941-4165-b950-9db79e72659d",
      PendingTimesheetSignoffForMoreThanId: "c8dc7692-9f00-4757-9d97-cc2b76b6dd47",
      SignoffRequestNotSentForPreviousMonthId: "b7158277-efee-4932-95bc-2b2f8fb8fb5a",
    },
  },
};
//#endregion

// #region widget categories
export enum WIDGET_CATEGORIES {
  ALL = "d6576ef1-3b8a-4d2f-a484-04e04f60b2e5",
  MY_COMPANY = "524f432d-f995-4590-a945-f2f1577bcf41",
  MY_TEAM = "c5c4a3e5-0040-4131-9704-279398a8599f",
  MYSELF = "8784434d-351c-44bb-968e-ef5c1ecfdb90",
  SYSTEM = "991b5d3d-2a10-4f3b-8532-5dd2837cb560",
}
//#endregion

//#region Alert line report status
export const ALERT_LINE_REPORT_STATUS = {
  Submitted: {
    id: "73ec794c-1cb9-4b43-a6ba-e585453e54bb",
    name: "Submitted",
    description: "Submitted",
    code: "SBM",
  },
  In_progress: {
    id: "509c5a81-ad73-4905-ae9d-9ad65c45e7da",
    name: "In progress",
    description: "In progress",
    code: "IPRGS",
  },
  Cancelled: {
    id: "21838476-309b-47bd-b5d2-e678e6f652d3",
    name: "Discarded & closed",
    description: "Discarded & closed",
    code: "DISC",
  },
  Closed: {
    id: "3a5fd4b0-2cf6-4009-88d0-70ca1848795f",
    name: "Processed & closed",
    description: "Processed & closed",
    code: "CLD",
  },
};
//#endregion

//#region available languages
export const AVAILABLE_LANGUAGES = {
  ENGLISH: {
    id: "d37effa1-a655-4eb4-a1c5-e37225f8682a",
    name: "English",
    code: "en",
  },
  FRENCH: {
    id: "5145efd0-2c42-4237-9903-8231c465eef7",
    name: "French",
    code: "fr",
  },
  SPANISH: {
    id: "e187773a-8a66-4d16-8ed5-711d90709537",
    name: "Spanish",
    code: "es",
  },
  ITALIAN: {
    id: "2cafbd6b-9a33-4592-adce-a8cf56a512f6",
    name: "Italian",
    code: "it",
  },
  ARABIC: {
    id: "63a756f8-1e5f-475c-a3e1-752eff837006",
    name: "Arabic",
    code: "ar",
  },
  CATALAN: {
    id: "fbb31e91-59d2-410b-bacd-b33aa18010ac",
    name: "catalan",
    code: "ca",
  },
};
//#endregion

//#region user activity actions
export const USER_ACTIVITY_ACTIONS = {
  RequestedExtraHours: {
    id: "9372377f-dbb5-4945-9c2f-b0aa4cd92daa",
  },
  ApprovedExtraHoursAsTeamManager: {
    id: "83eca7f9-84d3-4ad5-86a9-4beaf89de235",
  },
  RejectedExtraHoursAsTeamManager: {
    id: "30110d97-b981-4e4e-a4b9-eb1e8309c61f",
  },
  ApprovedExtraHoursByLinkAsTeamManager: {
    id: "f257acf8-711f-4943-aa02-ca085b55d79d",
  },
  RejectedExtraHoursByLinkAsTeamManager: {
    id: "573c8468-c80e-4afa-8292-4f837c952224",
  },
  EnteredBillableTime: {
    id: "d0113dbd-0848-4919-9fb4-fe2d0333a881",
  },
  CancelledExtraHours: {
    id: "ac860709-5e41-4386-8a9d-722d82ac1174",
  },
  AcceptedExtraHoursByLinkAsClientTeamManager: {
    id: "08695db9-98c8-4403-af33-bedb393ed087",
  },
  RejectedExtraHoursByLinkAsClientTeamManager: {
    id: "d671fd65-89b4-4c74-87cd-e3107591036e",
  },
  AcceptedExtraHoursAsClientTeamManager: {
    id: "34e1eafa-222f-4fbb-975a-1fd19b8e50a8",
  },
  RejectedExtraHoursAsClientTeamManager: {
    id: "964b2cd2-c48a-4597-b6f2-f8c3894802f3",
  },
  LoggedIn: {
    id: "b9cb60de-94e6-4dd4-82e7-75a977618500",
  },
  Requested2FaCode: {
    id: "c5813325-3344-4fdc-a79d-19c882ed0d2a",
  },
  LoggedInWith2FaCode: {
    id: "e3597365-5355-4aea-a5f8-c983f547cc99",
  },
};
//#endregion

//#region Mobile app prefix
export const APP_MOBILE_APP_PREFIX = "MobileApp";
//#endregion

//#region Incoming Mail Status
export const INCOMING_MAIL_STATUSES = {
  Pending: {
    name: "Pending",
    id: "eef425a0-51b1-4602-a2a9-5852826a7d87",
  },
  Discarded: {
    name: "Discarded",
    id: "cd8bdbcd-9b14-4714-863b-99b2404b4151",
  },
  Emailed: {
    name: "Emailed",
    id: "e2fb1bdb-9274-4c6f-ac37-427dfac511bd",
  },
};
//#endregion

//#region Incoming Mail Status
export const OUTGOING_MAIL_STATUSES = {
  Pending: {
    name: "Pending",
    id: "69b14d04-ac5b-472b-b3b1-0e65984a2c6c",
  },
  Discarded: {
    name: "Discarded",
    id: "53185ad7-b433-4d79-8fcb-313a2e8f307d",
  },
  Posted: {
    name: "Posted",
    id: "027fd732-9a7a-4296-b4ed-4d3677709a0c",
  },
};
//#endregion

//#region Mail classification status
export const MAIL_CLASSIFICATION_STATUS = {
  ToBeClassified: {
    name: "To be classified",
    id: "f2b9ba4c-6565-4bd7-9c52-aeb18134f545",
  },
  WillNotBeClassified: {
    name: "Will not be classified",
    id: "9a7d4770-88e5-4b20-9842-6d1b6493287a",
  },
  Classified: {
    name: "Classified",
    id: "87128a41-0fba-4c8d-bdf9-177332bae6b0",
  },
};
//#endregion

//#region Mail posting options
export const MAIL_POSTING_OPTIONS = {
  PriorityPost: {
    id: "26e2051b-3525-4900-9d79-ebf8156d47e8",
    name: "Priority post",
  },
  StandardPost: {
    id: "2dff928a-490e-4c97-8bf5-4817126726ea",
    name: "Standard post",
  },
  PostWithReceipt: {
    id: "4772e6f3-b0f9-4de4-8e09-70b401011845",
    name: "Post with receipt",
  },
  Courier: {
    id: "cb783ad8-bbd1-4294-a2b6-d9b59f0372ad",
    name: "Courier",
  },
};
//#endregion

//#region Employee survey configuration item type
export const EmployeeSurveyConfigurationItemType = {
  Question: {
    id: "63ac6bc5-668c-4d18-aadf-f5e0de91d2f1",
    name: "Question",
    maxTextLength: true,
    ranking: false,
    listOfAnswers: false,
    polarQuestion: false,
  },
  Ranking: {
    id: "baa926fa-5cea-44a0-afe1-c4068265aa6d",
    name: "Ranking",
    maxTextLength: false,
    ranking: true,
    listOfAnswers: false,
    polarQuestion: false,
  },
  YesORNo: {
    id: "bacaf4ab-1a6c-43e7-9c10-b4256087c718",
    name: "Yes / No",
    maxTextLength: false,
    ranking: false,
    listOfAnswers: false,
    polarQuestion: stubTrue,
  },
  PredefinedAnswers: {
    id: "96ac5264-6b12-4fb1-b7bb-d5f048b88768",
    name: "Yes / No",
    maxTextLength: false,
    ranking: false,
    listOfAnswers: true,
    polarQuestion: false,
  },
};
//#endregion

//#region employee survey configuration statuses
export const EmployeeSurveyConfigurationStatuses = {
  Ongoing: {
    id: "58b4fa59-f4f5-4ea8-91e3-7064735a17a2",
    name: "Ongoing",
  },
  Closed: {
    id: "a88d3d82-6882-4675-af33-0c4562b3ef19",
    name: "Closed",
  },
  Draft: {
    id: "b623490b-c079-4626-9662-9a94ab4de79d",
    name: "Draft",
  },
  Cancelled: {
    id: "26eb7850-8eae-498b-8df8-8207b1d3ceaf",
    name: "Cancelled",
  },
};
//#endregion

//#region employee survey Statuses
export const EmployeeSurveyStatuses = {
  Draft: {
    id: "897cf775-63da-499a-a0a5-3f1ec3934d55",
    name: "Draft",
  },
  Submitted: {
    id: "c14f266a-663e-4b23-8294-809825fd6a5d",
    name: "Submitted",
  },
  Pending: {
    id: "83dc6e92-a783-4b90-875e-f8dcfbe72a86",
    name: "Pending",
  },
};
//#endregion

//#region Provider advertisement popups status
export const ProviderSiteAdvertisementPopupsStatus = {
  Active: {
    name: "Active",
    id: "f1f73e98-ee7f-436b-9d51-2251b7c38f14",
  },
  Inactive: {
    name: "Inactive",
    id: "e87be3e8-b36b-4140-99e4-c8efaa4cf4ad",
  },
  Cancelled: {
    name: "Cancelled",
    id: "60554802-e64c-4330-9381-2f304f6e3edd",
  },
};
//#endregion

//#region Shareholder types
export const LegalPartyTypes = {
  Individual: {
    name: "Individual",
    id: "806f7249-d6f0-4e9d-9349-3ecfed027094",
  },
  Company: {
    name: "Company",
    id: "d0d54634-b6d8-44c0-8f16-6bee747b4725",
  },
};
//#endregion

// #region Document to sign statuses
export const DocumentToSignStatuses = {
  Open: {
    name: "Open",
    id: "5976c4e2-8e9d-4e10-b81d-0fd7bfeb82f8",
  },
  Closed: {
    name: "Closed",
    id: "dfd8ae10-d37b-4b50-8e2d-4f52e0b9556c",
  },
  Cancelled: {
    name: "Cancelled",
    id: "e2b7b1a3-1b7a-4e71-9c8a-fb8e3b245f91",
  },
  Draft: {
    name: "Draft",
    id: "6d181cbd-0e0c-4913-9f7d-0cddfa48471c",
  },
};
// #endregion
